import { render, staticRenderFns } from "./CargoTrack.vue?vue&type=template&id=2b1512b0&"
import script from "./CargoTrack.vue?vue&type=script&lang=js&"
export * from "./CargoTrack.vue?vue&type=script&lang=js&"
import style0 from "./CargoTrack.vue?vue&type=style&index=0&id=2b1512b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports